import { render, staticRenderFns } from "./PlantAssetAssignmentEdit.vue?vue&type=template&id=2b367888&scoped=true"
import script from "./PlantAssetAssignmentEdit.vue?vue&type=script&lang=js"
export * from "./PlantAssetAssignmentEdit.vue?vue&type=script&lang=js"
import style0 from "./PlantAssetAssignmentEdit.vue?vue&type=style&index=0&id=2b367888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b367888",
  null
  
)

export default component.exports